// const API_URL = process.env.REACT_APP_API_URL;
const API_URL = "https://acoin.in.rs:8001";

const handleError = (error: unknown, defaultMessage: string) => {
    if (error instanceof Error) {
        throw new Error(error.message);
    }
    throw new Error(defaultMessage);
};

export const addCoin = async (formDataToSend: FormData, token: string) => {
    try {
        const response = await fetch(`${API_URL}/coins/`, {
            method: "POST",
            body: formDataToSend,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.detail || "Error while adding coin");
        }

        return result;
    } catch (error) {
        handleError(error, "Something went wrong. Please try again.");
    }
};

export const getCoins = async (token: string) => {
    try {
        const response = await fetch(`${API_URL}/coins/`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.detail || "Error while fetching coins");
        }

        return result;
    } catch (error) {
        handleError(error, "Something went wrong. Please try again.");
    }
};

export const getCoinById = async (coinId: number, token: string) => {
    try {
        const response = await fetch(`${API_URL}/coins/${coinId}/`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.detail || "Error while fetching coin");
        }

        return result;
    } catch (error) {
        handleError(error, "Something went wrong. Please try again.");
    }
};

// Update coin
export const updateCoin = async (coinId: number, updatedData: any, token: string) => {
    try {
        const response = await fetch(`${API_URL}/coins/${coinId}/`, {
            method: "PUT",
            body: updatedData,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.detail || "Error while updating coin");
        }

        return result;
    } catch (error) {
        handleError(error, "Something went wrong. Please try again.");
    }
};

export const recognitionCoin = async (formDataToSend: FormData, token: string, coinId: number) => {
    try {
        const response = await fetch(`${API_URL}/coins/${coinId}/`, {
            method: "POST",
            body: formDataToSend,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.detail || "Error during coin recognition");
        }

        return result;
    } catch (error) {
        handleError(error, "Something went wrong. Please try again.");
    }
};

export const saveRecognition = async (formDataToSend: any, token: string, coinId: number) => {
    try {
        const response = await fetch(`${API_URL}/coins/save-recognition/${coinId}/`, {
            method: "POST",
            body: JSON.stringify(formDataToSend),
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        const result = await response.json();
        if (!response.ok) {
            throw new Error(result.detail || "Error while saving recognition data");
        }

        return result;
    } catch (error) {
        handleError(error, "Something went wrong. Please try again.");
    }
};